var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('picture',{class:_vm.cssAspectRatio,on:{"click":_vm.click}},[_vm._l((_vm.pictureResources),function(resource,index){return _c('source',{key:index,attrs:{"media":resource.media,"srcset":resource.srcset}})}),_vm._v(" "),(_vm.pictureResources[0] && _vm.pictureResources[0].srcset)?_c('img',{class:[
      _vm.cssAspectRatio,
      _vm.tailwindObjectFit[_vm.objectFit],
      _vm.fullSize ? 'w-full h-full' : 'max-w-full max-h-full',
    ],attrs:{"alt":_vm.image.altText || '',"title":_vm.image.title,"loading":_vm.lazy && 'lazy',"src":_vm.pictureResources[0].srcset},on:{"load":_vm.imageLoaded}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }